import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import * as Icons from 'react-bootstrap-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Confirmation from './ConfirmationModal';

const DeviceAdd = ({show, callback}) => {
  const [ addFormData, setAddFormData ] = useState({
      name: ''
    })
  
    const handleAddFormChange = (event) => {
      event.preventDefault();
  
      const fieldName = event.target.getAttribute('name');
      const fieldValue = event.target.value;
  
      const newFormData = { ...addFormData };
      newFormData[fieldName] = fieldValue;
  
      setAddFormData(newFormData);
  
      console.log('handleSave-newFormData',newFormData)
    }
  
  
    const handleSave = (event) => {
      event.preventDefault();
      console.log('handleSave', addFormData)
      callback(addFormData);
    }
  
    const closeForm = () => {
      console.log('close form')
      callback('close');
    }
  
    return (
      <>
        <Modal
          show={show}
          onHide={closeForm}

          backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title>Add Device</Modal.Title>
            </Modal.Header>
  
            <Modal.Body>
              <Form onSubmit={handleSave}>
                  <Form.Label>Site Id</Form.Label>
                  <Form.Control name="site_id" type="text" placeholder="Site id" onChange={handleAddFormChange} />
  
                  <Form.Label>Nimi</Form.Label>
                  <Form.Control name="name" type="text" placeholder="Nimi" onChange={handleAddFormChange} />

                  <Form.Label>Type</Form.Label>
                  <Form.Control name="type" type="text" placeholder="Type" onChange={handleAddFormChange} />

                  <Form.Label>Mac</Form.Label>
                  <Form.Control name="mac" type="text" placeholder="Mac"  onChange={handleAddFormChange} />
  
                  <Form.Label>U gain</Form.Label>
                  <Form.Control name="u_gain" type="text" placeholder="U gain"  onChange={handleAddFormChange} />
  
                  <Form.Label>U offset</Form.Label>
                  <Form.Control name="u_offset" type="text" placeholder="U offset"  onChange={handleAddFormChange} />
  
                  <Form.Label>U low limi</Form.Label>
                  <Form.Control name="u_low_limit" type="text" placeholder="U low limit"  onChange={handleAddFormChange} />
  
                  <Form.Label>U high limit</Form.Label>
                  <Form.Control name="u_high_limit" type="text" placeholder="U high limit"  onChange={handleAddFormChange} />

                  <Form.Label>I gain</Form.Label>
                  <Form.Control name="i_gain" type="text" placeholder="I gain"  onChange={handleAddFormChange} />
  
                  <Form.Label>I offset</Form.Label>
                  <Form.Control name="i_offset" type="text" placeholder="I offset"  onChange={handleAddFormChange} />
  
                  <Form.Label>I low limi</Form.Label>
                  <Form.Control name="i_low_limit" type="text" placeholder="I low limit"  onChange={handleAddFormChange} />
  
                  <Form.Label>I high limit</Form.Label>
                  <Form.Control name="i_high_limit" type="text" placeholder="I high limit"  onChange={handleAddFormChange} />

                  <Form.Label>Alarm delay</Form.Label>
                  <Form.Control name="alarm_delay" type="text" placeholder="Hälytysviive"  onChange={handleAddFormChange} />

                  <Form.Label>Save interval</Form.Label>
                  <Form.Control name="save_interval" type="text" placeholder="Tallennusväli"  onChange={handleAddFormChange} />

                  <Form.Label>Ref count</Form.Label>
                  <Form.Control name="ref_count" type="text" placeholder="Ref count"  onChange={handleAddFormChange} />

                  <Form.Label>Ref 1 name</Form.Label>
                  <Form.Control name="ref1_name" type="text" placeholder="Ref 1 name"  onChange={handleAddFormChange} />

                  <Form.Label>Ref 1 low limit</Form.Label>
                  <Form.Control name="ref1_low_limit" type="text" placeholder="Ref 1 low limit"  onChange={handleAddFormChange} />

                  <Form.Label>Ref 1 high limit</Form.Label>
                  <Form.Control name="ref1_high_limit" type="text" placeholder="Ref 1 high limit"  onChange={handleAddFormChange} />

                  <Form.Label>Ref 2 name</Form.Label>
                  <Form.Control name="ref2_name" type="text" placeholder="Ref 2 name"  onChange={handleAddFormChange} />

                  <Form.Label>Ref 2 low limit</Form.Label>
                  <Form.Control name="ref2_low_limit" type="text" placeholder="Ref 2 low limit"  onChange={handleAddFormChange} />

                  <Form.Label>Ref 2 high limit</Form.Label>
                  <Form.Control name="ref2_high_limit" type="text" placeholder="Ref 2 high limit"  onChange={handleAddFormChange} />

              </Form>
  
            </Modal.Body>
  
            <Modal.Footer>
              <Button onClick={closeForm}>Cancel</Button>
              <Button onClick={handleSave}>Save</Button>
            </Modal.Footer>
  
          </Modal>
      </>
    )
}

//** */
const ReadOnlyRow = ({ device, handleEditClick, handleDeleteRow, sites }) => {
  var site_title = sites.find(x => x.id === Number(device.site_id)).name;

  return (
    <>
      <tr key={device['id']}>
        <td><b>{device['id']}</b></td>
        <td><b>{site_title}</b></td>
        <td><b>{device['name']}</b></td>
        <td><b>{device['type']}</b></td>
        <td>{device['mac']}</td>
        <td>{device['u_gain']}</td>
        <td>{device['u_offset']}</td>
        <td>{device['u_low_limit']}</td>
        <td>{device['u_high_limit']}</td>
        <td>{device['i_gain']}</td>
        <td>{device['i_offset']}</td>
        <td>{device['i_low_limit']}</td>
        <td>{device['i_high_limit']}</td>
        <td>{device['alarm_delay']}</td>
        <td>{device['save_interval']}</td>
        <td>
            <button className="btn btn-primary" title="Edit" onClick={(event) => handleEditClick(event, device)}><Icons.Pencil /></button>
            <button className="btn btn-primary" title="Delete" onClick={() => handleDeleteRow(device['id'])}><Icons.Trash/></button>
      </td>
      </tr>

      {device.type === "mcadex" ? (
        <tr>
          <td colSpan="16">
            <Table>
                <thead>
                    <tr>
                      <th className="col-sm-1"></th>
                        <th>Ref count</th>
                        <th>Ref 1 nimi</th>
                        <th>Ref 1 low limit</th>
                        <th>Ref 1 high limit</th>
                        <th>Ref 2 nimi</th>
                        <th>Ref 2 low limit</th>
                        <th>Ref 2 high limit</th>
                    </tr>

                </thead>

                <tbody>
                    <tr>
                        <td></td>
                        <td>{device['ref_count']}</td>
                        <td>{device['ref1_name']}</td>
                        <td>{device['ref1_low_limit']}</td>
                        <td>{device['ref1_high_limit']}</td>
                        <td>{device['ref2_name']}</td>
                        <td>{device['ref2_low_limit']}</td>
                        <td>{device['ref2_high_limit']}</td>
                    </tr>
                </tbody>
            </Table>
          </td>
        </tr>
      ) : (
        <></>
      )}


    </>
  )

}

/** */
// Editoitava organization rivi
const EditableRow = ({ editFormData, handleEditFormChange, handleCancelClick, handleEditFormSelect, sites }) => {
  console.log('edit able row begin', editFormData)
  
  // Site comboboxin teksti
  var site_title = sites.find(x => x.id === Number(editFormData.site_id)).name;
  // Comboboxissa näytettävät sitet
  var site_items = [];
  sites.map((site) => {
    site_items = site_items.concat(<Dropdown.Item name="site_id" eventKey={site.id}>{site.name}</Dropdown.Item>);
  });

  // Device types 
  const device_types = [ "mcadex", "m2ex" ];
  var device_items = [];
  console.log('testiä alkaa')
  device_types.map((device) => {
    console.log('testiä', device)
    device_items = device_items.concat(<Dropdown.Item name="type" eventKey={device}>{device}</Dropdown.Item>);
  })
  console.log('testiä lopuuu', device_items)




  return (
    <>
    <tr>
      <td><b>{editFormData.id}</b></td>
      {/*<td><b><input type="text" required="required" placeholder="Enter site id" name="site_id" value={editFormData.site_id} onChange={handleEditFormChange} ></input></b></td>*/}
      <td>
        <DropdownButton required="required" title={site_title} onSelect={handleEditFormSelect}>
          {site_items}
        </DropdownButton>
      </td>
  
      <td><b><input type="text" required="required" placeholder="Enter name" name="name" value={editFormData.name} onChange={handleEditFormChange} ></input></b></td>
      {/*<td><b><input type="text" required="required" placeholder="Enter type" name="type" value={editFormData.type} onChange={handleEditFormChange} ></input></b></td>*/}
      <td>
        <DropdownButton required="required" title={editFormData.type} onSelect={handleEditFormSelect}>
          {device_items}
        </DropdownButton>
      </td>      
      <td><b><input type="text" required="required" placeholder="Enter mac" name="mac" value={editFormData.mac} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter u_gain" name="u_gain" value={editFormData.u_gain} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter u_offset" name="u_offset" value={editFormData.u_offset} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter u_low_limit" name="u_low_limit" value={editFormData.u_low_limit} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter u_high_limit" name="u_high_limit" value={editFormData.u_high_limit} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter i_gain" name="i_gain" value={editFormData.i_gain} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter i_offset" name="i_offset" value={editFormData.i_offset} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter i_low_limit" name="i_low_limit" value={editFormData.i_low_limit} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter i_high_limit" name="i_high_limit" value={editFormData.i_high_limit} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter alarm_delay" name="alarm_delay" value={editFormData.alarm_delay} onChange={handleEditFormChange} ></input></b></td>
      <td><b><input type="text" placeholder="Enter save_interval" name="save_interval" value={editFormData.save_interval} onChange={handleEditFormChange} ></input></b></td>
      <td>
        <button className="btn btn-primary" type="button" onClick={handleCancelClick}>Cancel</button>
        <button className="btn btn-primary" type="submit">Save</button>
      </td>
    </tr>

    {editFormData.type === "mcadex" ? (
      <tr>
      <td colSpan="16">
        <Table>
            <thead>
                <tr>
                  <th className="col-sm-1"></th>
                    <th>Ref count</th>
                    <th>Ref 1 nimi</th>
                    <th>Ref 1 low limit</th>
                    <th>Ref 1 high limit</th>
                    <th>Ref 2 nimi</th>
                    <th>Ref 2 low limit</th>
                    <th>Ref 2 high limit</th>
                </tr>

            </thead>

            <tbody>
                <tr>
                    <td></td>
                    <td><b><input type="text" required="required" placeholder="Enter ref_count" name="ref_count" value={editFormData.ref_count} onChange={handleEditFormChange} ></input></b></td>
                    <td><b><input type="text" placeholder="Enter ref1_name" name="ref1_name" value={editFormData.ref1_name} onChange={handleEditFormChange} ></input></b></td>
                    <td><b><input type="text" placeholder="Enter ref1_low_limit" name="ref1_low_limit" value={editFormData.ref1_low_limit} onChange={handleEditFormChange} ></input></b></td>
                    <td><b><input type="text" placeholder="Enter ref1_high_limit" name="ref1_high_limit" value={editFormData.ref1_high_limit} onChange={handleEditFormChange} ></input></b></td>
                    <td><b><input type="text" placeholder="Enter ref2_name" name="ref2_name" value={editFormData.ref2_name} onChange={handleEditFormChange} ></input></b></td>
                    <td><b><input type="text" placeholder="Enter ref2_low_limit" name="ref2_low_limit" value={editFormData.ref2_low_limit} onChange={handleEditFormChange} ></input></b></td>
                    <td><b><input type="text" placeholder="Enter ref2_high_limit" name="ref2_high_limit" value={editFormData.ref2_high_limit} onChange={handleEditFormChange} ></input></b></td>
                </tr>
            </tbody>
        </Table>
      </td>
      </tr>
    ) : (
      <></>
    ) }


    </>
  )
}



const Devices = ({database, main_callback}) => {
  
  const devices = database['devices'];
  var sites = database['sites'];
  const [show, setShow] = useState(false);
  const [editDeviceId, setEditDeviceId] = useState(null);
  const [editFormData, setEditFormData] = useState([]);

  const [showConfirmation, setShowConfirmation] = useState(false);  
  const [rowIdToDelete, setRowIdToDelete] = useState(null);

  const eventFromChild = (event) => {
    console.log('event from child', event)
    // TODO: Laitetaanko tähän tallennus vai viedäänkö Appin tasolle?
    // Suljettaessa formia tulee ainoastaan teksti close
    if (event !== "close")
      main_callback('add', 'devices', event);
    
    setShow(false);
  }

  // Edit kenttää muutettu
  const handleEditFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);

    console.log('edit changed', newFormData)
  };

  // Valittu alasvetovalikosta
  const handleEditFormSelect = (eventKey, event)  => {
    const fieldName = event.target.getAttribute("name");
    const fieldValue = eventKey;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);
  };

  /** */
  // Editoitavalla rivillä painetaan save-nappia
  const handleEditFormSubmit = (event) => {
    event.preventDefault();
/*
    const editedDevice = {
      id: editDeviceId,
      organization_id: editFormData.organization_id,
      name: editFormData.name,
      email: editFormData.email,
      phone: editFormData.phone,
      username: editFormData.username,
      password: editFormData.password,
      level: editFormData.level
    }
*/
    const newDevice = [...devices];
    const index = devices.findIndex((device) => device.id === editFormData.id);
    newDevice[index] = editFormData;
    //setEditFormData(newOrganization);
    console.log('edit submit', editDeviceId, newDevice)
    
    main_callback('update', 'devices', newDevice);
    
    setEditDeviceId(null);
  }

  // Editoitavalla painetaan cancel-nappia
  const handleCancelClick = () => {
    console.log('edit cancelled')
    setEditDeviceId(null);
  }


  /** */
  // ReadOnly-rivillä painetaan edit-nappia
  const handleEditClick = (event, device) => {
    console.log('edit click', event, device)
    event.preventDefault();
    setEditDeviceId(device.id);

    const formValues = {
      id: device.id,
      site_id: device.site_id,
      name: device.name,
      type: device.type,
      mac: device.mac,
      u_gain: device.u_gain,
      u_offset: device.u_offset,
      u_low_limit: device.u_low_limit,
      u_high_limit: device.u_high_limit,
      i_gain: device.i_gain,
      i_offset: device.i_offset,
      i_low_limit: device.i_low_limit,
      i_high_limit: device.i_high_limit,
      alarm_delay: device.alarm_delay,
      save_interval: device.save_interval,

      ref_count: device.ref_count,
      ref1_name: device.ref1_name,
      ref1_low_limit: device.ref1_low_limit,
      ref1_high_limit: device.ref1_high_limit,
      ref2_name: device.ref2_name,
      ref2_low_limit: device.ref2_low_limit,
      ref2_high_limit: device.ref2_high_limit,
    };

    console.log('edit click form', formValues)

    setEditFormData(formValues);
    console.log('edit click after', editFormData)
  };


  // Read-only rivillä painetaan deleteä -> näytetään varmistusdialogi (alla)
  const handleDeleteRow = (id, index) => {
    console.log('handleDeleteRow', id, index)
    //main_callback('delete', 'devices', id)
    setRowIdToDelete(id);

    // Kysytään varmistus poistoon
    setShowConfirmation(true);    
  }

  // Jos käyttäjä vahvistaa poiston -> lähetetään backendille poistettavan rivin id
  const confirmation_callback = (confirmation) =>{
    if (confirmation === "confirm") {
      main_callback('delete', 'devices', rowIdToDelete)
      setRowIdToDelete(null);
    }

    // Piiletetaan lopuksi vahvistusdialogi
    setShowConfirmation(false);
  }  


  return (
        <>
        <h2>Suojauspiirit</h2>
        {/*<Table bordered striped hover info="true">*/}
        <form onSubmit={handleEditFormSubmit}>
          <Table>
          <thead>
            <tr>
              <th>Id</th>
              <th>Site</th>
              <th>Nimi</th>
              <th>Type</th>
              <th>Mac</th>
              <th>U gain</th>
              <th>U offset</th>
              <th>U low limit</th>
              <th>U high limit</th>
              <th>I gain</th>
              <th>I offset</th>
              <th>I low limit</th>
              <th>I high limit</th>
              <th>Hälytysviive</th>
              <th>Tallennusväli</th>
              <th>Actions</th>

            </tr>
          </thead>

          <tbody>
            {devices.map((device) => (
                <Fragment key={device.id}>
                  
                {editDeviceId === device.id ? (
                  <EditableRow editFormData={editFormData} handleEditFormChange={handleEditFormChange} handleCancelClick={handleCancelClick} handleEditFormSelect={handleEditFormSelect} sites={sites} />
                ) : (
                  <ReadOnlyRow device={device} handleEditClick={handleEditClick} handleDeleteRow={handleDeleteRow} sites={sites} />
                )}
                

              </Fragment>

            ))}
          </tbody>


        </Table>
      </form>

      <DeviceAdd show={show} callback={eventFromChild}></DeviceAdd>

      <Confirmation className="delete-confirmation" show={showConfirmation} callback={confirmation_callback}></Confirmation>

      <button 
        className="btn btn-primary" 
        onClick={() => setShow(true)}>
          Add
      </button>      

      </>
    )
}


export default Devices;